import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column } from "@faire/web--source/slate/Layout";
import { LoadingSkeleton } from "@faire/web--source/slate/LoadingSkeleton";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import React from "react";
export var CarouselLoadingSkeleton = function() {
    return /*#__PURE__*/ _jsxs(Column, {
        style: {
            marginLeft: getSpacing("2x"),
            marginRight: getSpacing("2x")
        },
        "data-test-id": "carousel-loading-skeleton",
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            /*#__PURE__*/ _jsx(LoadingSkeleton, {
                width: "100px",
                height: "32px"
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            /*#__PURE__*/ _jsx(LoadingSkeleton, {
                width: "100%",
                height: {
                    mobileAndAbove: "250px",
                    tabletAndAbove: "300px",
                    desktopAndAbove: "350px"
                }
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            })
        ]
    });
};
